import React from "react";
import './ActionCardComponent.scss';
import { ReactComponent as ArrowIcon } from '../../../assets/icons/forward-arrow.svg'

interface CardComponentProps {
    icon: React.ReactNode
    text: string
    subtext?: string
    arrow?: boolean
    onCardClick?: () => void
    fontColor?: string
    gradient?: boolean
    secondaryGradient?: boolean
    noBackground?: boolean
}

export const ActionCardComponent: React.FC<CardComponentProps> = ({icon, text, subtext, arrow, onCardClick, fontColor, gradient, secondaryGradient, noBackground}: CardComponentProps) => {

    const onClick = () => {
        if (onCardClick) {
            onCardClick()
        }
    }

    const addBackground = () => {
        if (noBackground) {
            return 'card-icon-no-background'
        }
        if (gradient) {
            return 'card-icon-background-gradient'
        }
        if (secondaryGradient) {
            return 'card-icon-background-gradient-secondary'
        }
        return 'card-icon-background'
    }

    return (
        <div className="card-component-container" onClick={() => onClick()}>
            <div className={`card-component-icon ${addBackground()} flex-center`}>
                {icon}
            </div>
            <div className="card-component-text width-full flex-start">
                <div className={`primary-color font-md-plus flex-start`}>{text}</div>
                {subtext && <div className={`width-full flex-start font-sm card-component-subtext`} style={{color: fontColor ?? ''}}>{subtext}</div>}
            </div>

            {arrow ? (
                <div className="card-component-arrow">
                    <ArrowIcon/>
                </div>
            ) : ('')}

        </div>
    )

}